/**
 * External Dependencies
 */
import Mark from 'mark.js';
import { debounce } from 'throttle-debounce';

// Filters
$(() => {
  if($('body').hasClass('document-library')) {
    $('body').removeClass('document-library');
  }

  $('.document-library .dropdown-menu a.dropdown-toggle').on('click', function(e) {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
    }

    $(this).parent().toggleClass('show');
    $(this).next('.dropdown-menu').toggleClass('show');

    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
      $('.dropdown-menu .show').removeClass('show');
    });

    return false;
  });

  $('.document-library .filter-toggle').on('click', function() {
    let $self = $(this);
    // $self.nextAll().toggle();

    $self.nextAll().find('> a, > div').toggleVisibility();

    $self.toggleClass('is-open');

    $('.filter-toggle').not(this).removeClass('is-open');
    $('.filter-toggle').not(this).nextAll().find('> a, > div').css('visibility', 'hidden');

    return false;
  });

  $('.document-library .backlevel').on('click', function(e) {
    let $self = $(this);

    if (window.matchMedia("(max-width: 767px)").matches) {
      $self.parent().parent().prev().trigger('click');
      $self.parent().parent().removeClass('visible');
      $self.parent().parent().parent().parent().removeClass('invisible');
      $self.parent().parent().parent().closest('ul.filter__column').find('.filter-toggle').removeClass('is-open');
      $self.parent().parent().prev().removeAttr('checked');

      $('.filter__hidden').each(function() {
        let filterToggleDefaultLabel = $(this).find('a').text();

        $(this).next().next().find('a').text(filterToggleDefaultLabel);
      });
    }
  });

  $('#filter-tabs a[data-toggle="tab"]').on('click', function() {
    $('.document-library .dropdown.show a.dropdown-toggle').trigger('click');
    $('#filter-sub').removeClass('has-content');
    $('#filter-sub ul').removeClass('visible invisible');
    $('#filter-sub ul li.filter-toggle-collapse').find('> a, > div').css('visibility', 'hidden');
    $('.document-library .filter__item input[type="radio"]').parent().removeClass('selected');
    $('.document-library a.dropdown-toggle').removeAttr('checked');

    $('.filter__hidden').each(function() {
      let $self = $(this);

      let filterToggleDefaultLabel = $self.find('a').text();

      $self.next().next().find('a').text(filterToggleDefaultLabel);
    });

    $('.filter-toggle').removeClass('is-open');
  });

  // prevent from autoclose when clicking outside the dropdown
  $('.document-library .filter-dropdown').on('hide.bs.dropdown', function (e) {
    if (e.clickEvent) {
      e.preventDefault();
    }
  });

  // autoscroll on shown tab
  $('#filter-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    const header = $('.header').height();
    const wpadminbar = $('#wpadminbar').height();
    let $selector = $(this).closest('#filter-main');

    $selector.next().find('input[type="radio"]').removeAttr('checked');
    $selector.next().find('input[type="radio"]').prop('checked', false);

    window.history.replaceState({}, '', `${window.location.pathname}`);

    $('.document-library__contents').children().remove();

    if (window.matchMedia("(min-width: 768px)").matches) {
      if($('#wpadminbar').length){
        $('html,body').animate({
          scrollTop: $selector.offset().top - (header + wpadminbar),
        }, 500);
      }else {
        $('html,body').animate({
          scrollTop: $selector.offset().top - (header),
        }, 500);
      }
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      if($('#wpadminbar').length){
        $('html,body').animate({
          scrollTop: $selector.offset().top - (header + wpadminbar + 50),
        }, 500);
      }else {
        $('html,body').animate({
          scrollTop: $selector.offset().top - (header + 50),
        }, 500);
      }
    }
  });

  if($('body').hasClass('page-template-template-documentlibrary')) {
    // open dropdown
    $('.document-library .dropdown-toggle[checked="checked"], .document-library .filter__item input[checked="checked"]').closest('ul.dropdown-menu').prev().trigger('click');

    // open filter toggle
    // $('.document-library .dropdown-toggle[checked="checked"], .document-library .filter__item input[checked="checked"]').closest('ul.navbar-nav').find('.filter-toggle').trigger('click');

    // change label of filter toggle based on filter selected
    $('.filter__tabpane.active ul.navbar-nav > li .dropdown-toggle[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.navbar-nav > li > .dropdown-toggle[checked="checked"]').text());
    $('.filter__tabpane.active ul.navbar-nav > li input[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.navbar-nav > li > div > input[checked="checked"]').next().text());
    $('.filter__tabpane.active ul.dropdown-menu > li .dropdown-toggle[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.dropdown-menu > li > .dropdown-toggle[checked="checked"]').text());
    $('.filter__tabpane.active ul.dropdown-menu > li input[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.dropdown-menu > li > div > input[checked="checked"]').next().text());

    $('input[type="radio"]').filter(':checked').parent().addClass('selected');

    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.dropdown-toggle[checked="checked"]').parent().parent().addClass('invisible');
      $('.dropdown-toggle[checked="checked"]').next().addClass('visible');

      if($('.dropdown-toggle[checked="checked"]').css('visibility') === 'visible') {
        $('.dropdown-toggle[checked="checked"]').closest('ul.filter__column').find('> li.filter-toggle').nextAll().find('> a, > div').toggleVisibility();
      }
    }
  }

  $('.document-library a.dropdown-toggle').on('click', function(e) {
    $(this).closest('ul.filter__column').find('a.dropdown-toggle').removeAttr('checked');
    $(this).attr('checked', 'checked');

    $('#filter-sub').addClass('has-content');

    $('.document-library .filter__item input[checked="checked"]').parent().removeClass('selected');
    $('.document-library .filter__item input[checked="checked"]').removeAttr('checked');
    $('.document-library .filter__item input[checked="checked"]').prop('checked', false);

    $('.document-library__contents').children().remove();

    if($(this).parent().hasClass('grand-parent')) {
      $('.filter__hidden').each(function() {
        let $self = $(this);

        let filterToggleDefaultLabel = $self.find('a').text();

        $self.next().next().find('a').text(filterToggleDefaultLabel);
      });
    }

    $(this).closest('ul.filter__column').find('> li.filter-toggle > a').text($(this).text());

    $(this).closest('ul.filter__column').find('> li > ul.filter__column > li.filter-toggle > a').text($(this).closest('ul.filter__column').find('> li > ul.filter__column > .filter__hidden a').first().text());

    if (window.matchMedia("(min-width: 768px)").matches) {
      if($('.filter-toggle').hasClass('is-open')){
        $('.filter-toggle.is-open').trigger('click');
      }
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      $(this).parent().parent().addClass('invisible');
      $(this).next().addClass('visible');

      // $self.parent().find('> a, > div').toggleVisibility();
      if($(this).css('visibility') === 'visible') {
        $(this).closest('ul.filter__column').find('> li.filter-toggle').nextAll().find('> a, > div').toggleVisibility();
      }
    }
  });
  let page_param = ajax_documentlibrary_data.current_page;

  // Radio Ajax Filter
  $(document).on('change', '[data-filter="hwli-cat"], [data-filter="hii-cat"], [data-filter="he-cat"], [data-filter="ui-cat"]', function() {
    const $self = $(this);
    const $parentEl = $self.closest('.document-library');

    $('#filter-sub').addClass('has-content');

    $('.filter-toggle.is-open').trigger('click');

    $self.closest('ul.filter__column').find('> li > a.dropdown-toggle').filter('[checked="checked"]').trigger('click');

    if($self.is('input:radio')) {
      $parentEl.find('[data-filter="hwli-cat"], [data-filter="hii-cat"], [data-filter="he-cat"], [data-filter="ui-cat"]').not($self).removeAttr('checked');
      $self.attr('checked', false);
      $self.filter(':checked').attr('checked', true);

      $parentEl.find('[data-filter="hwli-cat"], [data-filter="hii-cat"], [data-filter="he-cat"], [data-filter="ui-cat"]').not($self).parent().removeClass('selected');
      $self.parent().addClass('selected');
    }

    $('.filter__tabpane.active ul.navbar-nav > li input[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.navbar-nav > li > div > input[checked="checked"]').next().text());
    $('.filter__tabpane.active ul.dropdown-menu > li input[checked="checked"]').closest('ul').find('> .filter-toggle a').text($('ul.dropdown-menu > li > div > input[checked="checked"]').next().text());

    $self.closest('ul.filter__column').find('> li > ul > .filter-toggle a').text($self.closest('ul.filter__column').find('> li > ul > .filter__hidden a').first().text());

    $self.closest('ul.filter__column').find('a.dropdown-toggle').removeAttr('checked');

    let hwliCheckedVal = $parentEl.find('[data-filter="hwli-cat"]').filter(':checked').map(function(){
      return $(this).val();
    }).get();

    let hiiCheckedVal = $parentEl.find('[data-filter="hii-cat"]').filter(':checked').map(function(){
      return $(this).val();
    }).get();

    let heCheckedVal = $parentEl.find('[data-filter="he-cat"]').filter(':checked').map(function(){
      return $(this).val();
    }).get();

    let uiCheckedVal = $parentEl.find('[data-filter="ui-cat"]').filter(':checked').map(function(){
      return $(this).val();
    }).get();

    let data = {
      action: 'documentlibrary',
      hansard_worldwide_limited_index: hwliCheckedVal.join(','),
      hansard_international_limited: hiiCheckedVal.join(','),
      hansard_europe: heCheckedVal.join(','),
      union_insurance: uiCheckedVal.join(','),
    };
    $.ajax({
      url : ajax_documentlibrary_data.ajaxurl,
      data: data,
      type: 'GET',
      beforeSend: function( xhr ){
        $('.page-load-status').show();
        $('.document-library__contents').addClass('-blur');
        $('.filter__tabpane,.filter__tabs').css('pointer-events', 'none');
      },
      success: function(data) {
        if( data ) {
          const $output = $(data).find('.document-library__contents').html();
          if( $(data).find('.document-library__contents').length ){
            $parentEl.find('.document-library__contents').html( $output );
          }else {
            $parentEl.find('.document-library__contents').children().remove();
          }

          // Reset page param
          page_param = 1;

          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }else {
          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }
      },
    });
  });

  // Search AJAX Filter
  $(document).on('submit', '.document-library .search-form', function(event) {
    event.preventDefault();

    const $self = $(this);
    const $parentEl = $self.closest('.document-library');

    let $selector = $parentEl.find('#filter-main');

    $selector.next().find('input[type="radio"]').removeAttr('checked');
    $selector.next().find('input[type="radio"]').prop('checked', false);

    $('.document-library a.dropdown-toggle').removeAttr('checked');
    $('.document-library .filter__item input[type="radio"]').parent().removeClass('selected');

    $('.document-library .dropdown.show a.dropdown-toggle').trigger('click');
    $('#filter-sub ul').removeClass('visible invisible');
    $('#filter-sub ul li.filter-toggle-collapse').find('> a, > div').css('visibility', 'hidden');

    $('.filter__hidden').each(function() {
      let $self = $(this);

      let filterToggleDefaultLabel = $self.find('a').text();

      $self.next().next().find('a').text(filterToggleDefaultLabel);
    });

    let data = {
      action: 'documentlibrary',
      qs: $parentEl.find('.search-field__input').val(),
    };
    $.ajax({
      url : ajax_documentlibrary_data.ajaxurl,
      data: data,
      type: 'GET',
      beforeSend: function( xhr ){
        $('.page-load-status').show();
        $('.document-library__contents').addClass('-blur');
        $('.filter__tabpane,.filter__tabs').css('pointer-events', 'none');
      },
      success: function(data){
        if( data ) {
          const $output = $(data).find('.document-library__contents').html();
          if( $(data).find('.document-library__contents').length ){
            $parentEl.find('.document-library__contents').html( $output );
          }else {
            $parentEl.find('.document-library__contents').children().remove();
          }

          // highlight text based on search value
          let instance = new Mark('.document-library__item-row');
          instance.mark($parentEl.find('.search-field__input').val(), {
            exclude: [
              '.document-library__item-group',
              '.document-library__document-pdf'
            ],
          });

          // Reset page param
          page_param = 1;

          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }else {
          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }
      },
    });
  });

  // Search as you type with AJAX Filter
  $(document).on('input', '.document-library #search-input-documentlibrary', debounce(1000, function(event) {

    const $self = $(this);
    const $parentEl = $self.closest('.document-library');

    let $selector = $parentEl.find('#filter-main');

    $selector.next().find('input[type="radio"]').removeAttr('checked');
    $selector.next().find('input[type="radio"]').prop('checked', false);

    $('.document-library a.dropdown-toggle').removeAttr('checked');
    $('.document-library .filter__item input[type="radio"]').parent().removeClass('selected');

    $('.document-library .dropdown.show a.dropdown-toggle').trigger('click');
    $('#filter-sub ul').removeClass('visible invisible');
    $('#filter-sub ul li.filter-toggle-collapse').find('> a, > div').css('visibility', 'hidden');

    $('.filter__hidden').each(function() {
      let $self = $(this);

      let filterToggleDefaultLabel = $self.find('a').text();

      $self.next().next().find('a').text(filterToggleDefaultLabel);
    });

    if($self.val() !== '') {
      $parentEl.find('.filter__category').css('display', 'none');
      $parentEl.find('#clear-filters').css('display', 'inline-flex');
    }else {
      $parentEl.find('.filter__category').css('display', 'block');
      $parentEl.find('#clear-filters').css('display', 'none');
    }

    let data = {
      action: 'documentlibrary',
      qs: $parentEl.find('.search-field__input').val(),
    };
    $.ajax({
      url : ajax_documentlibrary_data.ajaxurl,
      data: data,
      type: 'GET',
      beforeSend: function( xhr ){
        $('.page-load-status').show();
        $('.document-library__contents').addClass('-blur');
        $('.filter__tabpane,.filter__tabs').css('pointer-events', 'none');
      },
      success: function(data){
        if( data ) {
          const $output = $(data).find('.document-library__contents').html();
          if( $(data).find('.document-library__contents').length ){
            $parentEl.find('.document-library__contents').html( $output );
          }else {
            $parentEl.find('.document-library__contents').children().remove();
          }

          // highlight text based on search value
          let instance = new Mark('.document-library__item-row');
          instance.mark($parentEl.find('.search-field__input').val(), {
            exclude: [
              '.document-library__item-group',
              '.document-library__document-pdf'
            ],
            separateWordSearch: false,
          });

          // Reset page param
          page_param = 1;

          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }else {
          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }
      },
    });
  }));

  // Clear search filter
  $(document).on('click', '.document-library #clear-filters', function(event) {

    const $self = $(this);
    const $parentEl = $self.closest('.document-library');

    $self.css('display', 'none');

    $parentEl.find('.filter__category').css('display', 'block');

    let $selector = $parentEl.find('#filter-main');

    $selector.next().find('input[type="radio"]').removeAttr('checked');
    $selector.next().find('input[type="radio"]').prop('checked', false);

    $('.document-library a.dropdown-toggle').removeAttr('checked');
    $('.document-library .filter__item input[type="radio"]').parent().removeClass('selected');

    $('.document-library .dropdown.show a.dropdown-toggle').trigger('click');
    $('#filter-sub ul').removeClass('visible invisible');
    $('#filter-sub ul li.filter-toggle-collapse').find('> a, > div').css('visibility', 'hidden');

    $('.filter__hidden').each(function() {
      let $self = $(this);

      let filterToggleDefaultLabel = $self.find('a').text();

      $self.next().next().find('a').text(filterToggleDefaultLabel);
    });

    $parentEl.find('[type="search"]').val('');

    let data = {
      action: 'documentlibrary',
      qs: $parentEl.find('.search-field__input').val(),
    };
    $.ajax({
      url : ajax_documentlibrary_data.ajaxurl,
      data: data,
      type: 'GET',
      beforeSend: function( xhr ){
        $('.page-load-status').show();
        $('.document-library__contents').addClass('-blur');
        $('.filter__tabpane,.filter__tabs').css('pointer-events', 'none');
      },
      success: function(data){
        if( data ) {
          const $output = $(data).find('.document-library__contents').html();
          if( $(data).find('.document-library__contents').length ){
            $parentEl.find('.document-library__contents').html( $output );
          }else {
            $parentEl.find('.document-library__contents').children().remove();
          }

          // Reset page param
          page_param = 1;
          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }else {
          $('.page-load-status').hide();
          $('.document-library__contents').removeClass('-blur');
          $('.filter__tabpane,.filter__tabs').css('pointer-events', '');
        }
      },
    });
  });
});

$.fn.toggleVisibility = function (state) {
  return this.each(function () {
    $(this).css("visibility", state ? "visible" :
      (state === false ? "hidden" :
        $(this).css("visibility") === "hidden" ? "visible" : "hidden"));
  });
};
